import React from 'react';
import classNames from 'classnames';
import { I18n } from '@fiverr-private/fiverr_context';
import Notice from '../Notice';
import { boldFormatter } from '../formatters/bold';
import { dateFormatter } from '../formatters/date';
import { deleteMessage } from '../api/delete';
import { wrapTextWithTagFormatter } from '../formatters/wrapTextWithTag';
import { discountPromoCodeNoticeType } from './propTypes';
import { LAYOUTS } from './constants';

import styles from './style.module.scss';

const DiscountPromoCodeNotice = ({
    messageId,
    userId,
    withExpirationDate,
    discount,
    code,
    expirationDate,
    termsAndConditionSlug,
    layout = LAYOUTS.ROW
}) => {
    const onDismiss = () =>
        deleteMessage({ messageId, userId });

    return (
        <Notice message={discount}
            className={classNames(layout, { [styles.withoutExpiration]: !withExpirationDate })}
            onDismiss={onDismiss}>
            <div className={styles.details}>
                <span className={styles.code}>
                    <I18n k="layout.promo_code_notice.code"
                        params={{ code }}
                        templates={[boldFormatter, wrapTextWithTagFormatter(styles.checkout)]}/>
                </span>
                <span className={styles.extraDetails}>
                    {withExpirationDate && <span className={styles.expiration}>
                        <I18n k="layout.promo_code_notice.expiration"
                            params={{ expirationDate: dateFormatter(expirationDate) }}/>
                    </span>}
                    <a href={`/${termsAndConditionSlug}`}
                        className={styles.terms}>
                        <I18n k="layout.promo_code_notice.terms"
                            templates={[wrapTextWithTagFormatter(styles.conditions)]}/>
                    </a>
                </span>
            </div>
        </Notice>
    );
};

DiscountPromoCodeNotice.propTypes = discountPromoCodeNoticeType;

export { LAYOUTS } from './constants';
export default DiscountPromoCodeNotice;
